import { AdminRoleUsersDirectory } from "@/features/admin/components/AdminRoleUsersDirectory";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/users/secretaries")({
    component: SecretariesUsersPage,
});

function SecretariesUsersPage() {
    return (
        <>
            <AdminRoleUsersDirectory role="SECRETARY" emptyLabel="secretaries" />
            <Outlet />
        </>
    );
}
